import * as max from '../max-length-validators';

export default {
  name: 'addressLine2',
  label: 'checkout.address.field.label.address2.text',
  maxLength: 35,
  validate: max.lengthAddress(35),
};
